import Cookies from "js-cookie";
import React, { useState, useEffect } from "react";
import Navbar from "../../../Components/Navbar";
import { fetchProfile } from "../../../utils/fetchProfile";
import SearchBarSetupProduct from "../../../Components/SearchBarSetup";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import {
  Autocomplete,
  TextField,
  IconButton,
  Modal,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Paper,
} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import {
  fetchDataProductMaster,
  fetchExportDataProductMaster,
  exportproductmastersetup,
} from "./DataUtil";
import ImportModalSetup from "./Modalimport";
import { Slide, toast } from "react-toastify";

const tableCellStyle = {
  whiteSpace: "nowrap",
  backgroundImage: "linear-gradient(#0ab9cc, #069dae)",
  color: "#FFF",
  fontWeight: "bold",
  position: "sticky",
  top: 0,
  zIndex: 1000,
  minWidth: 120,
  textAlign: "center",
};

// button style
const BootstrapButton = styled(Button)({
  backgroundImage: "linear-gradient(#0ab9cc, #069dae)",
  border: "1px solid hsl(186, 89.90%, 27.30%)",
  borderRadius: "4px",
  color: "#fff",
  fontSize: { xs: "14px", sm: "16px" },
  padding: "4px 10px",
  textTransform: "none",
  "&:hover": {
    backgroundImage: "linear-gradient(#0991a2, #057d8c)",
  },
});

function SetupUnitvolProduct() {
  const [sortBy, setSortBy] = useState("id");
  const [sortOrder, setSortOrder] = useState("desc");
  const [dataUnitvol, setdataUnitvol] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedExportType, setSelectedExportType] = useState("unitvol");
  const [searchDataValue, setSearchDataValue] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [filteredRows, setFilteredRows] = useState([]);
  const [notAllowAccessPage, setNotAllowAccessPage] = useState(false);
  const [dataProfile, setDataProfile] = useState([]);
  const accessToken = Cookies.get("access_token") || "";
  const [searchBarValue, setSearchBarValue] = useState("unitvol");
  const [modalAddCreate, setModalAddCreate] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);

  const [pageUnitvol, setPageUnitvol] = useState(0);
  const [rowsPerPageUnitvol, setRowsPerPageUnitvol] = useState(10);
  const [totalRowsUnitvol, setTotalRowsUnitvol] = useState(0);

  //import
  const [openDialogImport, setOpenDialogImport] = useState(false);

  async function fetchUnitvol() {
    try {
      const queryParams = new URLSearchParams();

      if (pageUnitvol !== undefined && pageUnitvol !== null) {
        queryParams.append("page", pageUnitvol + 1);
      }

      if (rowsPerPageUnitvol) {
        queryParams.append("size", rowsPerPageUnitvol);
      }

      queryParams.append("sort_by", sortBy);
      queryParams.append("sort_order", sortOrder);

      if (searchDataValue) {
        queryParams.append("column_value", searchDataValue);
        queryParams.append("column_operator", "LIKE");
      }
      
      const queryString = queryParams.toString();
      const apiUrl =
        `${process.env.REACT_APP_API_URL}/api/v1/unitvol` +
        (queryString ? `?${queryString}` : "");

      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          authorization: "Bearer " + accessToken,
        },
      });

      if (response.ok) {
        const data = await response.json();
        setdataUnitvol(data.data);
        setTotalRowsUnitvol(data.pagination_info.total);
      }
    } catch (e) {
      console.error(e);
    }
  }

  const [selectedCategory, setselectedCategory] = useState(
    localStorage.getItem("selectedCategory") || "all"
  );
  const [selectedBrand, setselectedBrand] = useState(
    localStorage.getItem("selectedBrand") || "all"
  );
  const [selectedPrincipal, setselectedPrincipal] = useState(
    localStorage.getItem("selectedPrincipal") || "all"
  );
  const [selectedStockunit, setselectedStockunit] = useState(
    localStorage.getItem("selectedStockunit") || "all"
  );
  const [selectedPacksize, setselectedPacksize] = useState(
    localStorage.getItem("selectedPacksize") || "all"
  );
  const [selectedPacktype, setselectedPacktype] = useState(
    localStorage.getItem("selectedPacktype") || "all"
  );
  const [selectedFlavour, setselectedFlavour] = useState(
    localStorage.getItem("selectedFlavour") || "all"
  );
  const [selectedUnitvol, setselectedUnitvol] = useState(
    localStorage.getItem("selectedUnitvol") || "all"
  );
  const [selectedBrandCategoryMaster, setselectedBrandCategoryMaster] =
    useState(localStorage.getItem("selectedBrandCategoryMaster") || "all");

  const handleExportData = async () => {
    await fetchDataProductMaster(
      accessToken,
      setIsLoading,
      setFilteredRows,
      "unitvol", // Endpoint
      selectedCategory,
      selectedBrand,
      selectedPrincipal,
      selectedStockunit,
      selectedPacksize,
      selectedPacktype,
      selectedFlavour,
      selectedUnitvol,
      selectedBrandCategoryMaster
    );

    // Panggil fetchExportDataStoreMaster dengan parameter yang sesuai
    fetchExportDataProductMaster(
      accessToken,
      setIsLoading,
      selectedExportType,
      selectedCategory,
      selectedBrand,
      selectedPrincipal,
      selectedStockunit,
      selectedPacksize,
      selectedPacktype,
      selectedFlavour,
      selectedUnitvol,
      selectedBrandCategoryMaster
    );
  };

  const handleChangePageUnitvol = (event, newPage) => {
    setPageUnitvol(newPage);
  };

  const handleChangeRowsPerPageUnitvol = (event) => {
    setRowsPerPageUnitvol(parseInt(event.target.value, 10));
    setPageUnitvol(0);
  };

  // funtionbuttoncreate
  const handleAddCreate = () => {
    setModalAddCreate(true);
  };

  const handleSetupInputChange = (event) => {
    const { name, value } = event.target;
    setNewUnitvol((prevUnitvol) => ({
      ...prevUnitvol,
      [name]: value,
    }));
  };

  //Unitvol
  const [newUnitvol, setNewUnitvol] = useState({
    id: "",
    desc: "",
  });

  const handleCreateUnitvol = async () => {
    try {
      const token = Cookies.get("access_token");

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/v1/unitvol`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(newUnitvol),
        }
      );

      if (response.status === 201) {
        alert("UnitVol Berhasil dibuat!");
        setModalAddCreate(false);
        setPageUnitvol(0);
        await fetchUnitvol();
        setNewUnitvol({});
      } else if (response.status === 400) {
        const data = await response.json();
        alert(data.detail);
      } else {
        alert("UnitVol Gagal Dibuat!");
      }
    } catch (error) {
      console.error("Error creating UnitVol", error);
    }
  };

  const handleCloseEditModal = () => {
    setEditModalOpen(false);
  };

  const HandleEditUnitvol = async (row) => {
    setEditUnitvolId(row.id);
    setEditModalOpen(true);
    setEditedUnitvol(row);
  };
  const [editUnitvolId, setEditUnitvolId] = useState(null);
  const [editedUnitvol, setEditedUnitvol] = useState({
    desc: "",
  });
  const handleUpdateUnitvol = async () => {
    setIsLoading(true);
    if (editUnitvolId) {
      const token = Cookies.get("access_token");
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/v1/unitvol/${editUnitvolId}`,
          {
            method: "PATCH",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(editedUnitvol),
          }
        );

        if (response.status === 200) {
          alert("Unitvol Berhasil di update");
          setEditModalOpen(false);
          await fetchUnitvol();
        } else {
          alert("Unitvol gagal di update");
        }
      } catch (error) {
        console.error(error);
      }
    }
    setIsLoading(false);
  };

  const dataSetupOptions = [
    { label: "Category", value: "category" },
    { label: "Brand", value: "brand" },
    { label: "Principal", value: "principal" },
    { label: "Stock Unit", value: "stock-unit" },
    { label: "Unitvol", value: "unitvol" },
    {
      label: "Brand Category Master",
      value: "brand-category-master",
    },
  ];

  //function serach bar
  const handleTableSelection = (newValue) => {
    if (newValue) {
      setSearchBarValue(newValue.value);
      setTimeout(() => {
        window.location.href = newValue.value;
      }, 100);
    }
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchUnitvol();
    }, 200);
    return () => {
      clearTimeout(handler);
    };
  }, [pageUnitvol, rowsPerPageUnitvol, searchBarValue, accessToken, sortBy, sortOrder, searchDataValue]);

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchProfile(accessToken, setDataProfile, setNotAllowAccessPage, [
        "13",
        "14",
      ]);
    }, 200);
    return () => {
      clearTimeout(handler);
    };
  }, [accessToken]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setSearchDataValue(inputValue);
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [inputValue]);

  //import
  const [fileUrl, setFileUrl] = useState("");
  const [excelFile, setExcelFile] = useState("");

  const handleImport = () => {
    setOpenDialogImport(true);
  };
  const handleCloseDialog = () => {
    setOpenDialogImport(false);
    setFileUrl("");
    setExcelFile("");
  };

  // export product master setup template
  async function exportproductmastersetupTemplate() {
    setIsLoading(true);
    const blob = await exportproductmastersetup(
      accessToken,
      "template",
      "api/v1/product-master/export/setup_template",
      {}
    );
    if (blob) {
      // throw data as blob then download it
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "Template Product Master Setup.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
    } else {
      toast.error("Gagal mendownload template Setup Product Master!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Slide,
      });
    }
    setIsLoading(false);
  }

  // import setup Product master
  async function importProductmastersetupTemplate() {
    try {
      const formData = new FormData();
      formData.append("file", excelFile);

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/v1/product-master/import_product_master_setup`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          body: formData,
        }
      );

      if (response.status === 201) {
        toast.success("Upload Product Master Setup berhasil dibuat!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
        fetchUnitvol();

        // close
        setOpenDialogImport(false);
      } else if (response.status === 200) {
        // throw data as blob then download it when validation on excel got fail
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "Product Master Setup Error.xlsx";
        document.body.appendChild(a);
        a.click();
        a.remove();
        toast.error("Ada masalah di excel. Periksa kembali isi excel!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      } else if (response.status === 400) {
        const data = await response.json();
        toast.error(data.detail, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      } else {
        toast.error("Gagal mengimport Product Master Setup!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
        console.error(
          "Failed to import Product Master Setup template:",
          response.statusText
        );
      }
    } catch (error) {
      console.error("Error importing Product Master Setup template:", error);
    }
  }

  const handleUpload = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    importProductmastersetupTemplate();
    setIsLoading(false);
  };

  // sorting
  const handleSort = (column) => {
    const isSorting = sortBy === column && sortOrder === "asc";
    setSortOrder(isSorting ? "desc" : "asc");
    setSortBy(column);
  };

  const sortTableCell = (label, sortByKey) => (
    <TableCell style={tableCellStyle} sx={{ border: 1, borderColor: 'grey.300' }}>
      <TableSortLabel
        active={sortBy === sortByKey}
        direction={sortOrder}
        onClick={() => handleSort(sortByKey)}
        sx={{
          color: "#FFF !important",
          "&:hover": {
            color: "#FFF",
          },
          "& .MuiTableSortLabel-icon": {
            color: "#FFF !important",
          },
        }}
      >
        {label}
      </TableSortLabel>
    </TableCell>
  );

  return (
    <div>
      <Navbar
        active="Setup Product Master"
        initial={dataProfile.initial}
        role_code={dataProfile.role_code}
      />
      <div style={{ padding: "1rem" }}>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "10px",
            marginTop: "30px",
            marginBottom: "20px",
          }}
        >
          <Autocomplete
            options={dataSetupOptions}
            getOptionLabel={(option) => option.label}
            value={
              dataSetupOptions.find(
                (option) => option.value === searchBarValue
              ) || null
            }
            onChange={(e, newValue) => handleTableSelection(newValue)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Cari Kategori"
                size="small"
                style={{ width: "300px" }}
              />
            )}
            isOptionEqualToValue={(option, value) =>
              option.value === value.value
            }
            disableClearable
          />
          <TextField
            variant="outlined"
            size="small"
            label="Search"
            sx={{ ml: 0 }}
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
          />

          {/* button */}
          <div className="button-setup" style={{ display: "flex", gap: "5px" }}>
            {searchBarValue !== "Category" && (
              <>
                <BootstrapButton
                  disableRipple
                  onClick={handleAddCreate}
                  disabled={isLoading}
                >
                  {isLoading ? "Loading..." : "Add"}
                </BootstrapButton>
                <BootstrapButton
                  onClick={() => handleImport()}
                  disableRipple
                  disabled={isLoading}
                >
                  {isLoading ? "Loading..." : "Upload"}
                </BootstrapButton>
              </>
            )}
            <BootstrapButton
              disableRipple
              onClick={handleExportData}
              disabled={isLoading}
            >
              {isLoading ? "Loading..." : "Download"}
            </BootstrapButton>
          </div>
        </div>
        <div>
          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer sx={{ maxHeight: 650 }}>
              <Table
                aria-label="simple table"
                sx={{
                  border: 1,
                  borderColor: "grey.300",
                  borderCollapse: "collapse",
                }}
              >
                <TableHead sx={{ backgroundColor: "rgb(6,157,174)" }}>
                  <TableRow>
                    {sortTableCell("ID", "id")}
                    {sortTableCell("Desc", "desc")} 
                    <TableCell
                      style={tableCellStyle}
                      sx={{ border: 1, borderColor: "grey.300" }}
                    >
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dataUnitvol.map((row) => (
                    <TableRow hover key={row.id}>
                      <TableCell
                        align="center"
                        sx={{ border: 1, borderColor: "grey.300" }}
                      >
                        {row.id}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ border: 1, borderColor: "grey.300" }}
                      >
                        {row.desc}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ border: 1, borderColor: "grey.300" }}
                      >
                        <Tooltip
                          title="Edit Unitvol"
                          onClick={() => HandleEditUnitvol(row)}
                        >
                          <IconButton>
                            <EditIcon />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                  {dataUnitvol.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={4} align="center">
                        No data available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50, 100]}
              component="div"
              count={totalRowsUnitvol}
              rowsPerPage={rowsPerPageUnitvol}
              page={pageUnitvol}
              onPageChange={handleChangePageUnitvol}
              onRowsPerPageChange={handleChangeRowsPerPageUnitvol}
            />
          </Paper>
        </div>

        {/* create product */}
        <Modal
          open={modalAddCreate}
          onClose={() => setModalAddCreate(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{ border: 0 }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: {
                xs: "90vw",
                sm: 400,
              },
              maxHeight: "90vh",
              bgcolor: "background.paper",
              border: "0px solid #000",
              boxShadow: 24,
              p: {
                xs: 2,
                sm: 4,
              },
              overflowY: "auto",
              borderRadius: 2,
            }}
          >
            <Tooltip title="Close Modal">
              <IconButton
                edge="end"
                color="inherit"
                onClick={() => setModalAddCreate(false)}
                sx={{ position: "absolute", top: 20, right: 30 }}
              >
                <CloseIcon />
              </IconButton>
            </Tooltip>
            <div className="Create-Unitvol">
              <h2 className="mb-2">Create Unitvol</h2>
              <div>
                <TextField
                  label="ID"
                  name="id"
                  value={newUnitvol.id}
                  onChange={handleSetupInputChange}
                  sx={{ width: "100%", mb: 2 }}
                />
              </div>
              <div>
                <TextField
                  label="DESCRIPTION"
                  name="desc"
                  value={newUnitvol.desc}
                  onChange={handleSetupInputChange}
                  sx={{ width: "100%", mb: 2 }}
                />
              </div>
              <div>
                <BootstrapButton
                  disableRipple
                  sx={{ width: "100%", mt: 2, height: 50, mb: 3 }}
                  onClick={handleCreateUnitvol}
                  disabled={isLoading}
                >
                  {isLoading ? "Loading..." : "Submit"}
                </BootstrapButton>
              </div>
            </div>
          </Box>
        </Modal>

        {/* Update Product */}
        <Modal
          open={editModalOpen}
          onClose={handleCloseEditModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{ border: 0 }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: {
                xs: "90vw",
                sm: 400,
              },
              maxHeight: "90vh",
              bgcolor: "background.paper",
              border: "0px solid #000",
              boxShadow: 24,
              p: {
                xs: 2,
                sm: 4,
              },
              overflowY: "auto",
              borderRadius: 2,
            }}
          >
            <div className="Unitvol-Update">
              <h2>Edit Unitvol</h2>
              <div>
                <TextField
                  name="desc"
                  label="Description"
                  value={editedUnitvol.desc}
                  sx={{ width: "100%", mb: 2 }}
                  onChange={(e) =>
                    setEditedUnitvol({
                      ...editedUnitvol,
                      desc: e.target.value,
                    })
                  }
                />
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Button
                    variant="outlined"
                    disableRipple
                    sx={{
                      width: "50%",
                      height: 50,
                      mt: 2,
                      color: "#b34469",
                      borderColor: "#b34469",
                    }}
                    onClick={handleCloseEditModal}
                  >
                    Cancel
                  </Button>
                  <BootstrapButton
                    disableRipple
                    sx={{ width: "50%", height: 50, mt: 2, mr: 0, ml: 2 }}
                    onClick={handleUpdateUnitvol}
                    disabled={isLoading}
                  >
                    {isLoading ? "Loading..." : "UPDATE"}
                  </BootstrapButton>
                </div>
              </div>
            </div>
          </Box>
        </Modal>

        <ImportModalSetup
          open={openDialogImport}
          onClose={handleCloseDialog}
          title={"Upload Setup Product Master"}
          buttonTitle={"Upload"}
          fileUrl={fileUrl}
          handleSubmit={handleUpload}
          handleChange={{
            excel: setExcelFile,
            fileUrl: setFileUrl,
          }}
          handleExport={exportproductmastersetupTemplate}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
}

export default SetupUnitvolProduct;
